import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';
import { IsNotEmpty, IsString, IsOptional } from 'class-validator';
import { AccreditationCheckStatus } from '../models/accreditation-status.enum';

export class AccountAccreditationStatusUpdateRequestDto {
    @ApiModelProperty({
        type: 'string',
        enum: Object.values(AccreditationCheckStatus),
    })
    status: AccreditationCheckStatus;

    @ApiModelProperty({
        type: 'string',
    })
    @IsOptional()
    statusMessage?: string;

    @ApiModelProperty({
        type: 'string',
    })
    @IsString()
    ncAccountId: string;
}
